import { LoaderModule } from '../../shared/components/loader/loader.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';

import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';

import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { VMessageModule } from 'src/app/shared/components/vmessage/vmessage.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';

import { InputMaskModule } from 'primeng/inputmask';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { SfGridGenericModule } from 'src/app/shared/components/grid-generic/grid-generic.module';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { WoNotarialSealGridComponent } from './wo-notarial-seal-grid.component';
import { WoNotarialSealService } from './wo-notarial-seal.service';
import { WoNotarialSealReserveComponent } from './wo-notarial-seal-reserve/wo-notarial-seal-reserve.component';
import { ScAddressModule } from 'src/app/features/sc-address/sc-address.module';


@NgModule({
    declarations: [WoNotarialSealGridComponent, WoNotarialSealReserveComponent],
    exports: [WoNotarialSealGridComponent, WoNotarialSealReserveComponent],
    imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        VMessageModule,
        RouterModule,
        NotificationsModule,
        ButtonModule,
        InputTextModule,
        TranslateModule,
        MessageModule,
        MessagesModule,
        TableModule,
        TooltipModule,
        InputMaskModule,
        CardModule,
        SfDropDownModule,
        ScAddressModule,
        DialogModule,
        LoaderModule,
        SfGridGenericModule

        ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, WoNotarialSealService]
})
export class WoNotarialSealModule { }
